import { useState } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { usePatchMatterMutation } from '@/services/api/mattersService';

import { MatterSectionCard } from './MatterSectionCard';

interface ReferralSourceCardProps {
  matterId: string;
  referralSource?: string;
}

export const ReferralSourceCard = ({
  matterId,
  referralSource,
}: ReferralSourceCardProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(referralSource || '');
  const [patchMatter, { isLoading }] = usePatchMatterMutation();

  const handleSave = async () => {
    try {
      await patchMatter({
        matter_id: matterId,
        patch: { referral_source_description: value },
      }).unwrap();
      toast.success('Referral source updated');
      setIsEditing(false);
    } catch {
      toast.error('Failed to update referral source');
    }
  };

  const handleCancel = () => {
    setValue(referralSource || '');
    setIsEditing(false);
  };

  return (
    <MatterSectionCard
      title="Referral Source"
      showEditButton={!isEditing}
      onEdit={() => setIsEditing(true)}
      isEditing={isEditing}
    >
      {isEditing ? (
        <div className="space-y-3">
          <Textarea
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Enter referral source..."
            className="text-sm"
            rows={2}
          />
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button size="sm" onClick={handleSave} disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </div>
      ) : (
        <p className="text-sm font-medium text-zinc-700">
          {referralSource || 'No referral source specified'}
        </p>
      )}
    </MatterSectionCard>
  );
};
